<!-- 合作銀行 :/partner_bank -->
<template>
  <div class="layout_wrapper partner_bank_wrapper">
    <div class="container_wrapper">
      <h2 class="page_main_title">
        合作銀行
      </h2>

      <div class="card_wrapper">
        <div
          v-for="(item, index) in bankImages"
          :key="index"
          class="card_item"
        >
          <img
            class="card_img"
            :src="`${apiUrl}partner_bank/bank_logo/${item}.png`"
            alt="card_img"
          >
        </div>
      </div>
    </div>

    <div class="huli_icon huli_icon_head" />
    <div class="huli_icon huli_icon_hand" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { apiUrl } from '@/config/config';
import { getBankList } from '@/libs/API/apis';

export default {
  name: 'PartnerBank',
  setup () {
    const bankImages = ref([]);

    onMounted(() => {
      getBankList('partner')
        .then((res) => {
          bankImages.value = res;
        });
    });

    return {
      apiUrl,
      bankImages
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';
@import '@/scss/common/layout.scss';

.partner_bank_wrapper {
  .card_wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: -10px;
    padding-bottom: 110px;

    .card_item {
      align-items: center;
      background: url('~@/assets/imgs/partnerBank/bank_card_bg.svg') no-repeat;
      background-position: top center;
      background-size: contain;
      display: flex;
      height: 122px;
      justify-content: center;
      margin: 10px;
      padding: 0px 4px 4px 0px;
      width: calc(25% - 20px);
    }

    .card_img {
      display: block;
      height: 30px;
      width: auto;
    }
  }

  .huli_icon {
    left: 50%;
    position: absolute;
    transform: translate(-50%, 0);
    width: 350px;

    &.huli_icon_head {
      background: url('~@/assets/imgs/partnerBank/huli_head.svg') no-repeat;
      background-size: contain;
      bottom: -44px;
      height: 204px;
      z-index: 1;
    }

    &.huli_icon_hand {
      background: url('~@/assets/imgs/partnerBank/huli_hand.svg') no-repeat right;
      background-size: contain;
      bottom: -15.6px;
      height: 43px;
      z-index: 3;
    }
  }
}

@include RWD_1024 {
  .partner_bank_wrapper {
    .card_wrapper {
      margin: -10px -22px;

      .card_item {
        margin: 10px 22px;
        width: calc(33.3% - 44px);
      }
    }
  }
}

@include RWD_768 {
  .partner_bank_wrapper {
    .card_wrapper {
      margin: -10px;
      padding-bottom: 160px;

      .card_item {
        height: 105px;
        margin: 10px;
        width: calc(33.3% - 20px);
      }
    }
  }
}

@include RWD_414 {
  .partner_bank_wrapper {
    .card_wrapper {
      margin: -5px;

      .card_img {
        height: calc((22 / 414) * 100vw);
      }

      .card_item {
        height: calc((86 / 414) * 100vw);
        margin: 5px;
        width: calc(50% - 10px);
      }
    }

    .huli_icon {
      width: 320px;

      &.huli_icon_head {
        bottom: -41px;
        height: 187px;
      }

      &.huli_icon_hand {
        bottom: -14px;
        height: 39px;
      }
    }
  }
}
</style>
